module.exports = __webpack_public_path__ + "4f39bfa938d744ee5fd51f046b38e0e2.MP3";